export const formHelpPartnerText = {
  title: 'Minta Bantuan',
  description: 'Pastikan data dibawah ini benar sebelum mengajukan bantuan pada operator',
  roomLabel: 'Ruangan',
  roomPlaceholder: 'Pilih Ruangan...',
  textAreaLabel: 'Catatan (opsional)',
  textAreaPlaceholder: 'contoh: tambah stok etalase 2',
};

export const requestingPartnerText = {
  title: 'Sedang mencari Operator',
  description: 'Mohon tunggu, kami sedang mencarikan operator yang akan membantu Anda.',
  buttonText: 'Batalkan',
  titleNoOperator: 'Operator Sedang Sibuk',
  descriptionNoOperator: 'Semua operator sedang menyelesaikan tugas lain. Tunggu sebentar, mereka akan membantu Anda',
};

export const donePartnerText = {
  title: 'Operator akan membantu',
  description: 'Operator sudah terhubung, bantuan segera datang.',
};

export const cancelModalText = {
  title: 'Apakah kamu yakin ingin membatalkan bantuan ini?',
  description: 'Setelah dibatalkan, kamu perlu meminta ulang jika butuh bantuan.',
  submitButton: 'Ya, batalkan',
  closeButton: 'Tidak',
};

export const helpHostModalText = {
  submitButtonText: 'Ya, Bantu Sekarang',
  roomText: 'Ruangan',
  hostText: 'Host',
  contentText: 'Host berikut membutuhkan bantuan segera.',
  titleText: 'Permintaan Bantu Rekan',
  notesText: 'Catatan',
};
